import { SalonList } from '@drycut/controlled-components';
import { Error404, Loader } from '@drycut/ui-components';
import React from 'react';
import { createBrowserRouter, Outlet } from 'react-router';

import { Container, ContainerLayout, Layout } from './components';
import {
  BookingDetailsByUid,
  NewBooking,
  NewPassPurchase,
  PassDetailsByUid,
  Passes,
  PassPurchaseError,
} from './routes';

export default createBrowserRouter([
  {
    element: (
      <Layout>
        <React.Suspense
          fallback={
            <Container>
              <Loader />
            </Container>
          }
        >
          <Outlet />
        </React.Suspense>
      </Layout>
    ),
    children: [
      {
        path: '/:slug',
        element: <NewBooking />,
      },
      {
        // Every screen below renders inside the standard card
        element: <ContainerLayout />,
        children: [
          {
            path: '/booking/:uid',
            element: <BookingDetailsByUid />,
          },
          {
            path: '/:slug/passes',
            element: <Passes />,
          },
          {
            path: '/:slug/passes/:passId/purchase',
            element: <NewPassPurchase />,
          },
          {
            path: '/:slug/pass/:uid',
            element: <PassDetailsByUid />,
          },
          {
            path: '/passes/payment-error/:transactionId',
            element: <PassPurchaseError />,
          },
        ],
      },
    ],
  },
  {
    path: '/',
    element: <SalonList />,
  },
  {
    path: '/not-found',
    element: <Error404 />,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);
